var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4upda",
    d: "M179 3278a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updf",
    d: "M153 3543.29c-.16.75-1 .86-1.5.92l-.72.07c0 .38 0 .76-.1 1.13-.03.1-.33.99-.44.97-.77-.16-.82-1-.9-1.46-.04-.2-.07-.4-.09-.61-.41 0-.83 0-1.23-.1-.1-.03-1.04-.34-1.02-.45.16-.76 1.05-.81 1.54-.9.23-.04.45-.06.68-.08v-.15c0-.33.02-.66.1-.98.02-.1.33-1 .44-.97.75.15.86.95.92 1.42l.07.65h.2c.34 0 .7.02 1.03.1.1.02 1.04.33 1.02.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updi",
    d: "M150.57 3283.99c-9.01.35-15.63-8.28-8.66-8.87 6.98-.59 10.09 1.17 10.09 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updb",
    d: "M143.24 3247.3h21.41v23.41h-21.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updk",
    d: "M150.3 3266.85c-.57-6.87-4.77-16.46-6.4-18.23-1.65-1.77-.02-1.75 2.92 0 2.16 1.28 15.6 9.52 17.65 18.23 2.06 8.7-14.16 0-14.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updl",
    d: "M153 3266.44c.31-3.2 5.71-6.4 9.2-6.44 3.5-.04 8.9 5.76 8.8 6.65-.1.9-18-.21-18-.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updc",
    d: "M145.16 3265.49h39.2v21.88h-39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updn",
    d: "M146.5 3266c-3.18 2.2-.85 20.01 8.73 20.81 9.58.8 26.86 1.62 28.76-4.34 1.9-5.97-3.76-13.62-9.18-15.42-5.41-1.8-27.14-1.88-28.32-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updd",
    d: "M171.99 3267.04h13.06v17.41H172z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updp",
    d: "M172 3269.5c.04 1.51.04 3.02.08 4.52.03 1.47.05 3.2.87 4.5.65 1.02 1.76 1.27 2.84 1.64 1.25.43 2.42 1.03 3.57 1.67 1.53.87 3.02 1.8 4.57 2.62.33-.39.6-.82.75-1.3 1.9-5.96-3.77-13.61-9.18-15.41-.81-.27-2-.5-3.42-.7-.07.82-.1 1.64-.08 2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updq",
    d: "M139.15 3279.83c4.76-.65 23.5-1.15 27.27-.59 3.76.57 8.38 2.51 7.46 3.95-.91 1.43-1.95 3.35-8.21 4.52-6.26 1.18-8.77-1.48-11.58-3.7-2.81-2.23-20.75-3.39-14.94-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updr",
    d: "M168.45 3286.2c1.12-.44 3.78-1.62 1.9-2.83-.98-.63-5.1-1.6-6.23-1.83-8.3-1.64-16.79-.47-25.12-1.54 3.09.71 13.41 1.7 15.5 3.23 1.9 1.38 3.66 2.93 6.48 3.5 2.21.6 5.92.09 7.47-.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4upde",
    d: "M135 3265.17h31.72v9.55H135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updt",
    d: "M136.74 3265.8c-.62.09-1.16.48-1.4 1.06a4.5 4.5 0 0 0-.27 2.53c.44 2.33 2.71 3.87 4.9 4.62 2.3.52 4.52.76 5.8.7 3.87-.18 20.95-8.83 20.95-8.83-2.83-.23-21-1.42-29.98-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updu",
    d: "M168.75 3273.02c-.09-.3-.15-.42-.44-.58-1.25-.68-3.48-.4-4.85-.28-.1.01-.2.12-.21.21-.08 1.18-.74 2.65.48 3.31 1.05.57 3.67.2 4.89.24.24 0 .4-.16.38-.39-.07-.79-.02-1.75-.25-2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updv",
    d: "M140.9 3272c-1.31-.73-.8-4-.8-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updw",
    d: "M145 3272c-1.12-.2-1-4-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updx",
    d: "M148 3272c0-1.66.82-3 .82-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updy",
    d: "M168 3284c-5.2-2.04-29-3-29-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updz",
    d: "M142 3277c-.07.53.58 1 .58 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4updA",
    d: "M173 3269c2.77.8 9.76 3.8 10 13-3.94-3.93-4.18-3.26-4.18-3.26"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "4updh",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179 3275h6v6h-6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4upda"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "4updg",
    width: 48,
    height: 48,
    x: 158,
    y: 3254,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceGraphic",
    result: "FeOffset6110Out"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "FeOffset6110Out",
    result: "FeGaussianBlur6111Out",
    stdDeviation: "4.4 4.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4updj"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4updb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4updm"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4updc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4updo"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4updd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4upds"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4upde"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -3247)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#d7d7ff",
    xlinkHref: "#4updf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -3247)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4updg)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    strokeWidth: 0,
    mask: "url(\"#4updh\")",
    xlinkHref: "#4upda"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2c8cf4",
    xlinkHref: "#4upda"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#4upda"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -3247)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#8181f5",
    xlinkHref: "#4updi"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4updj)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#b4b4ff",
    xlinkHref: "#4updk"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#b4b4ff",
    xlinkHref: "#4updl"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4updm)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#b4b4ff",
    xlinkHref: "#4updn"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4updo)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#b7ecff",
    xlinkHref: "#4updp"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#d6d5ec",
    xlinkHref: "#4updq"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#8181f5",
    xlinkHref: "#4updr"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4upds)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8181f5",
    xlinkHref: "#4updt"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#b7ecff",
    xlinkHref: "#4updu"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#4f5aa4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updv"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#4f5aa4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updw"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#4f5aa4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updx"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#4f5aa4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updy"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#4f5aa4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updz"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#f9fafb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 0.5,
    xlinkHref: "#4updA"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.b0033ba7deeafd4bc544f88a0d7093e1.svg";
export { ForwardRef as ReactComponent };